import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M3 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M17.585 17.587a2 2 0 0 0 2.813 2.843","key":"svg-2"}],["path",{"d":"M6.5 17.5l5.5 -4.5l5.5 4.5","key":"svg-3"}],["path",{"d":"M12 7v1m0 4v1","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconHierarchyOff = createReactComponent('outline', 'hierarchy-off', 'HierarchyOff', __iconNode);

export default IconHierarchyOff;